import { ScmType } from "@protos/common/v1/common";
import { Issue as IssueProto } from "@protos/issues/v1/issues";
import { formatProviderRef, getSanitizedUrl } from "@shared/utils";

import { getGitProvider } from "../getGitProvider";
import { getProviderRefUrl } from "../getProviderRefUrl";

/**
 * TODO: This information should be provided by the backend server.
 */
export const getGitProviderLinks = (issue: IssueProto | null) => {
  let repoUrl = getSanitizedUrl(issue?.lastSeenScan?.meta?.repo_url);
  if (repoUrl?.endsWith(".git")) {
    // sometimes the repoUrls have .git at the end
    // this will be fixed in semgrep CI, but we will still fix here
    repoUrl = repoUrl.slice(0, repoUrl.length - 4);
  }

  const pullRequestId = issue?.lastSeenScan?.meta?.pull_request_id;
  const unformattedRef = issue?.ref || "";

  const origin: ScmType | undefined = getGitProvider(repoUrl);
  const ref = formatProviderRef(origin, unformattedRef, pullRequestId);
  const refUrl = getProviderRefUrl(
    origin,
    repoUrl,
    pullRequestId,
    unformattedRef
  );

  return {
    refUrl,
    ref,
    provider: origin,
  };
};
